<!--该组件适用于分类选择，诸如优惠券分类选择
@author: Anya Parry
-->
<template>
  <div class="bar-background">
    <div v-for="(item, index) in titleBar"
         class="all-of-the-options"
         :style="{'width': 'calc(100% / ' + titleBar.length +')'}"
         @click="changed(index, item.value)">
      <div class="single-option"
            :class="index === selected ? 'single-option-selected' : ''">{{item.label}}&nbsp;{{item.length > 0 ? '(' +item.length +')' : ''}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bar',
  props: {
    titleBar: {
      type: Array,
      default: [
        {
          label: 'label',
          value: 'value'
        }
      ]
    }
  },
  data () {
    return {
      selected: 0
    }
  },
  methods: {
    changed (index, value) {
      this.selected = index
      this.$emit('change', value)
    }
  }
}
</script>

<style scoped src="../../views_fc/styleSheet/coupons.css">
</style>



// WEBPACK FOOTER //
// Bar.vue?455b9728